module.exports = __webpack_public_path__ + "img/VPC-banks.428d92f.jpg";